export default "__VITE_PUBLIC_ASSET__fc8a5f21__"